module.exports = __webpack_public_path__ + "static/img/king_card_2.9815e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/king_card_2.png
// module id = ZThn
// module chunks = 0